'use strict';

var Sugar = require('sugar-core'),
    objectNone = require('../enumerable/internal/objectNone');

Sugar.Object.defineInstanceAndStatic({

  'none': function(obj, f) {
    return objectNone(obj, f);
  }

});

module.exports = Sugar.Object.none;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/none.js
// module id = 829
// module chunks = 0